export default "__VITE_ASSET__5d720b24__"